var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"task-detail-section"},[_c('TaskDetailGeneralSection'),_c('TaskDetailPointSection',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedPointIdx !== null),expression:"selectedPointIdx !== null"}],attrs:{"fleetTaskInstantId":_vm.$route.params.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }